import { codeSplit, Controller, FetchOptions, Result } from 'bernie-core';

export class PzOAuthCallbackController implements Controller {
  public routeName = 'pz-partner';
  public pageId = 'pages.auth-pz-callback';
  public path = '/auth/pz-partner';
  public exact = true;
  public bundles = [];

  public component = codeSplit(
    () => import(/* webpackChunkName: "uis-prime-example-page" */ '../views/pz-oauth-callback'),
  );

  // tslint:disable-next-line:prefer-function-over-method
  public async fetch(options: FetchOptions) {
    if (!options.isServer) {
      const { request } = options;
      request.context.locale = !!localStorage?.getItem('locale')
        ? localStorage.getItem('locale')
        : request.context.locale;
    }

    return Promise.resolve(Result.ok());
  }

  // tslint:disable-next-line:prefer-function-over-method
  public fetchPageData() {
    return Promise.resolve({ title: 'PZ OAuth callback' });
  }
}
